import React from 'react';
import ReactDOM from 'react-dom';
import { Props, ButtonObject } from './model';
import './style.scss';
// import CrossIcon from 'Image/Icons/cross.svg';
import { asyncExecutor, getImage } from '../../utils';
import WarningIcon from '../../assets/icons/Warning.svg';
import Button from '../../DumpComponents/Button';

function Modal(props: React.PropsWithChildren<Props>) {
  const modalRoot = document.getElementById('modal-root') as Element;
  const modalRef: React.RefObject<HTMLDivElement> = React.useRef(null);

  const handleNewSeq = (ev: React.KeyboardEvent<HTMLDivElement>) => {
    if (ev.key === 'Escape') {
      props.onClose();
    }
  };
  React.useEffect(() => {
    if (modalRef.current) modalRef.current.focus();
  }, []);

  React.useEffect(() => {
    function handleClick(ev: Event) {
      const target = ev.target as HTMLDivElement;
      if (target.className === 'sf-modal-w') {
        if (!props.disableClickOutside) {
          props.onClose();
        }
      }
    }
    if (modalRef && modalRef.current) {
      modalRef.current.addEventListener('click', handleClick);
    }

    return () => {
      modalRef &&
        modalRef.current &&
        // eslint-disable-next-line react-hooks/exhaustive-deps
        modalRef.current.removeEventListener('click', handleClick);
    };
  }, [props]);

  return ReactDOM.createPortal(
    <div className='sf-modal-w' ref={modalRef} tabIndex={0} onKeyUp={handleNewSeq}>
      <div className='sf-modal-body' style={props.styles}>
        {props.hideCloseButton ? null : (
          <div>
            <img
              alt=''
              src={getImage('close-dark.svg')}
              onClick={() => asyncExecutor(props.onClose)}
              className={`hoverable ${props.disableCloseButton ? `disabled` : ``}`}
            />
          </div>
        )}
        {props.warningConfig ? (
          <div className='login-warning-modal-w'>
            <div className='login-warning-modal-title'>
              <img src={WarningIcon} alt='warning' />
              {props.warningConfig.title}
            </div>
            <div className='login-warning-modal-message'>
              {props.warningConfig.message}
            </div>
            <div className='login-warning-modal-actions'>
              {props.warningConfig.buttons.map((b: ButtonObject, i: number) => {
                return (
                  <Button key={i} title={b.title} theme={b.theme} onClick={b.onClick} />
                );
              })}
            </div>
          </div>
        ) : null}

        {/* {props.children} */}
      </div>
    </div>,
    modalRoot
  );
}

Modal.defa = {
  delay: 100,
};
export default Modal;
